<template lang="html">
  <div class="footer-helper body-14 gray">
    Need help? Visit our
    <a href="https://symbium.com/faqs" target="_blank" class="link-purple">Knowledge Base</a>
    or
    <a href="https://symbium.com/contact" target="_blank" class="link-purple">contact us</a>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.footer-helper {
  border-top: 1px solid var(--gray-divider);
  padding: 32px 0 80px;

  @media screen and (max-width: 768px) {
    padding-bottom: 64px; 
  }
}
</style>
